import React, { useEffect } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { FeedOptions } from '../types/rss';
import { GlobalStyles } from '../styles/GlobalStyles';

interface ThemeProviderProps {
  options: FeedOptions;
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ options, children }) => {
  // Aplica o tema ao body
  useEffect(() => {
    const body = document.body;
    
    // Remove classes de tema anteriores
    body.classList.remove('light-theme', 'dark-theme');
    
    // Determina o tema a ser aplicado
    let theme = options.theme;
    
    // Se o tema for 'auto', usa a preferência do sistema
    if (theme === 'auto') {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      theme = prefersDark ? 'dark' : 'light';
    }
    
    // Aplica a classe do tema
    body.classList.add(`${theme}-theme`);
    
    // Aplica customizações se habilitadas
    if (options.customTheme) {
      body.style.setProperty('--custom-font-size', `${options.fontSize}px`);
      body.style.setProperty('--custom-font-color', options.fontColor);
      body.style.setProperty('--custom-background-color', options.backgroundColor);
      body.classList.add('custom-theme');
    } else {
      body.classList.remove('custom-theme');
      body.style.removeProperty('--custom-font-size');
      body.style.removeProperty('--custom-font-color');
      body.style.removeProperty('--custom-background-color');
    }
  }, [options.theme, options.customTheme, options.fontSize, options.fontColor, options.backgroundColor]);
  
  // Create theme object for styled-components
  const themeObject = {
    mode: options.theme,
    customTheme: options.customTheme,
    fontSize: options.fontSize,
    fontColor: options.fontColor,
    backgroundColor: options.backgroundColor,
    colors: {
      primary: options.customTheme ? options.fontColor : (options.theme === 'dark' ? '#ffffff' : '#000000'),
      background: options.customTheme ? options.backgroundColor : (options.theme === 'dark' ? '#1a1a1a' : '#ffffff'),
      surface: options.theme === 'dark' ? '#2d2d2d' : '#f5f5f5'
    }
  };

  return (
    <StyledThemeProvider theme={themeObject}>
      <GlobalStyles />
      {children}
    </StyledThemeProvider>
  );
};